@if (provider || account) {
  <div
    class="payout-tile card-{{ getAvailable() ? 'interactive' : 'disabled' }}"
    (click)="tileClicked()"
    bp-tooltip="{{ tooltipText().length > 0 ? (tooltipText() | translate) : '' }}"
    position="top"
	[ngClass]="{
		'is-muted': !getAvailable(),
		'is-active': active,
		'tile-hover': getAvailable(),
		'mod-stack': isStacked
	}">
    <div class="payout-tile-container" [tabIndex]="0" (keydown.enter)="tileClicked()">
      <div class="payout-tile-top">
        @if (provider?.isLogoDescriptive() || providerForced.isLogoDescriptive()) {
          <div class="payout-tile-image-container">
            <a href="javascript:" [tabIndex]="-1">
              <img class="payout-tile-image" [src]="logoUrl(data)" alt="{{ getName() }}" />
            </a>
          </div>
        } @else {
          <div class="payout-tile-image-container payout-tile-image-container-with-text">
            <a href="javascript:" [tabIndex]="-1">
              <img class="payout-tile-image" [src]="logoUrl(data)" alt="{{ getName() }}" />
            </a>
            <span class="payout-tile-image-name">{{ getName() }}</span>
          </div>
        }
        @if (account) {
          <div class="payout-tile-actions">
            @if (isEditAble) {
              <a
                bp-tooltip="{{ 'withdraw_edit_button_hover' | translate }}"
                position="top"
                class="payout-tile-action"
                (click)="edit(); $event?.stopPropagation()"
                (keydown.enter)="edit(); $event?.stopPropagation()"
                href="javascript:">
                <span class="bpi__icon-edit"></span>
              </a>
            }
            @if (deleteAllowed) {
              <a
                bp-tooltip="{{ 'withdraw_delete_button_hover' | translate }}"
                position="top"
                class="payout-tile-action"
                (click)="delete(); $event?.stopPropagation()"
                (keydown.enter)="delete(); $event?.stopPropagation()"
                href="javascript:">
                <span class="bpi__icon-close-round"></span>
              </a>
            }
            @if (addAllowed) {
              <a
                bp-tooltip="{{ 'withdraw_add_button_hover' | translate }}"
                position="top"
                class="payout-tile-action"
                (click)="add(); $event?.stopPropagation()"
                (keydown.enter)="add(); $event?.stopPropagation()"
                href="javascript:">
                <span class="bpi__icon-plus-circle"></span>
              </a>
            }
          </div>
        }
        @if (showAction()) {
          <div class="payout-tile-top-text">
            @if (isInstant()) {
              <span class="text-blue">
                <span class="bpi__icon-superfast"></span> &nbsp;{{ "instant" | translate | uppercase }}
              </span>
            }
          </div>
        }
      </div>
      <div class="payout-tile-content">
        @if (isStacked) {
          <div class="payout-tile-data-strong">{{ "AMOUNT_accounts_stored" | translate: [stacks] }}</div>
        }
        @if (showDescription()) {
          <p [innerHTML]="getDescription()"></p>
        }
        @if (account) {
          @if (account?.getReceiverName() && !isSepa()) {
            <div class="payout-tile-data-strong pb-10">
              {{ account?.getReceiverName()?.getValue() }}
            </div>
          }
          @if (account?.getNameField()) {
            <p>{{ account?.getNameField()?.getValue() }}</p>
          }
          @if (primaryField && !isSepa()) {
            <div class="pb-5">{{ primaryField?.getValue() }}</div>
          }
          @if (isSepa()) {
            <div>
              <div class="font-size-15 pb-10">{{ getHolderName() }}</div>
              <div class="font-size-15 large-weight">{{ getPrimaryFieldValue() | iban_format }}</div>
              <div class="font-size-13">{{ getBankName() }}</div>
            </div>
          }
          @if (account.isCard()) {
            <div class="font-size-15 pb-10">{{ account.getField("card_holder").getValue() }}</div>
            <div class="font-size-15 large-weight" cardMask>{{ account.getField("card_mask").getValue() }}</div>
          }
          @if (!isSepa() && account?.getBankName()) {
            <div>{{ account?.getBankName()?.getValue() }}</div>
          }
        }
        <p class="payout-tile-fees">
          @if (hasFees()) {
            {{ ("fees" | translate) + ":" }} {{ feeString() }}
          } @else {
            @if (isSepa()) {
              {{ "free" | translate | capitalize }}
            }
          }
        </p>
        @if (!getAvailable() && fiats?.length > 0) {
          {{ "only_available_for_FIATS" | translate: [fiatsAvailable] }}
        }
      </div>
    </div>
  </div>
}


